'use strict';

import React from 'react';
import { Link as ReactRouterLink } from 'react-router';
import { createLocation } from 'history/lib/LocationUtils';
import _pickBy from 'lodash.pickby';

function isExternal(url) {
  return /^((tel:)|((f|ht)tps?:\/\/))/i.test(url);
}

const extractAttributes = props => {
  if (!props) {
    return {};
  }
  const attributes = {};
  attributes.href = props.to || props.href || props.url;
  attributes.children = props.text && !props.children ? props.text : props.children;
  attributes.target = props.target;
  attributes.name = props.name;
  attributes.className = props.className;
  attributes.onClick = props.onClick;
  attributes.title = props.title;
  attributes.tabIndex = props.tabIndex;
  attributes.style = props.style;

  // allow all `data-` attributes to pass through for test automation support and `aria` attributes for a11y support
  const dataAttrs = _pickBy(props, (prop, key) => {
    return key.includes('data-') || key.includes('aria-');
  });

  Object.assign(attributes, dataAttrs);

  return attributes;
};

const Link = props => {
  const attributes = extractAttributes(props);

  if (typeof attributes.children === 'string') {
    attributes.dangerouslySetInnerHTML = {
      __html: attributes.children
    };
    delete attributes.children;
  }

  if (attributes.href && !isExternal(attributes.href)) {
    const { href, ...rest } = attributes;
    const to = createLocation(href);
    return <ReactRouterLink to={to} {...rest} data-ux-router={true} />;
  }

  return <a {...attributes} />;
};

export default Link;
